
<cvt-dialog
  v-if="!AltPopupManager"
  size="lg"
  bg-color="#fff"
  :show="show"
  :show-close="false"
  :height-auto="true"
  :show-header="false"
  :show-footer="false"
>
  <div class="row mb-4 mt-4">
    <div class="col-md-10 text-center mx-auto">
      <h1 class="setup-title" :style="titleStyle">
        {{ $t('setup.message.title') }}
      </h1>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-10 text-center mx-auto">
      <h5 :style="titleStyle">{{ $t('setup.message.description') }}</h5>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-10 mx-auto">
      <cvt-input
        id="templateNameId"
        v-model="siteName"
        v-validate="validateSiteName"
        type="text"
        name="name"
        :label="$t('settings.page.label')"
        :clearable="false"
        :validation-status="nameInvalid ? 'invalid' : 'valid'"
        :valid-message="$t('settings.page.validation')"
        :invalid-message="$t('setup.template.name')"
      />
      <div v-show="nameInvalid" class="invalid-feedback">
        {{ $t('setup.template.name') }}
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="mx-auto">
      <cvt-button
        size="md"
        color="primary"
        text="Continue"
        theme="light"
        :outlined="false"
        :full-width="true"
        :disabled="nameInvalid"
        @click="$emit('continue')"
      />
    </div>
  </div>
</cvt-dialog>
<cvt-dialog
  v-else
  bg-color="#ffffff"
  size="sm"
  :show="show"
  :show-close="false"
  :height-auto="true"
  :show-header="false"
  :show-footer="false"
>
  <div class="row mb-2 mt-4">
    <div class="col-md-12">
      <h5 class="setup-title" :style="titleStyle">
        {{ $t('setup.message.title') }}
      </h5>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-md-12">
      <cvt-input
        v-model="siteName"
        v-validate="validateSiteName"
        type="text"
        name="name"
        :label="$t('settings.page.label')"
        :clearable="false"
        :validation-status="nameInvalid ? 'invalid' : 'valid'"
        :valid-message="$t('settings.page.validation')"
        :invalid-message="$t('setup.template.name')"
      />
      <div v-show="nameInvalid" class="invalid-feedback">
        {{ $t('setup.template.name') }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="ml-auto mr-3">
      <cvt-button
        size="sm"
        color=""
        text="Continue"
        theme="light"
        special-style="dark"
        :outlined="true"
        :full-width="true"
        :disabled="nameInvalid"
        @click="$emit('continue')"
      />
    </div>
  </div>
</cvt-dialog>
